globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.LazyLoader = {
  lazyLoad: function(options) {
    var lazyloader = this,
        options = options || {};

    var container = options.container ? options.container : document,
        $container = $(container);

    if(UserAgent.IE10orOlder()) {
      lazyloader.skipAll($container);
      return;
    }

    if(options.loadSkippedElements) {
      $container.find('.skip-lazyload').removeClass('skip-lazyload');
    }

    if($container.data('images-lazyload')) {
      $container.data('images-lazyload').update()
    } else {
      $container.data('images-lazyload', new LazyLoad({
        container: container,
        elements_selector: 'img',
        callback_enter: function(el) {
          lazyloader.loadImg(el);
        }
      }));
    }

    if($container.data('bg-images-lazyload')) {
      $container.data('bg-images-lazyload').update();
    } else {
      $container.data('bg-images-lazyload', new LazyLoad({
        container: container,
        elements_selector: ".bg-imaged:not(.skip-lazyload)",
        unobserve_entered: true,
        callback_enter: function(el) {
          lazyloader.loadBgImg(el);
        }
      }));
    }

    if($container.data('bg-videos-lazyload')) {
      $container.data('bg-videos-lazyload').update();
    } else {
      $container.data('bg-videos-lazyload', new LazyLoad({
        container: container,
        elements_selector: ".background-video-background",
        unobserve_entered: true,
        callback_enter: function(el) {
          lazyloader.loadBgVideo(el);
        }
      }));
    }

    if($container.data('albums-lazyload')) {
      $container.data('albums-lazyload').update();
    } else {
      $container.data('albums-lazyload', new LazyLoad({
        container: container,
        elements_selector: '.element-album',
        unobserve_entered: true,
        callback_enter: function(el) {
          lazyloader.loadElementAlbum(el, $container);
        }
      }));
    }

    if($container.data('maps-lazyload')) {
      $container.data('maps-lazyload').update();
    } else {
      $container.data('maps-lazyload', new LazyLoad({
        container: container,
        elements_selector: '.map-container',
        unobserve_entered: true,
        callback_enter: function(el) {
          lazyloader.loadGoogleMap(el);
        }
      }));
    }

    if($container.data('videos-lazyload')) {
      $container.data('videos-lazyload').update();
    } else {
      $container.data('videos-lazyload', new LazyLoad({
        container: container,
        elements_selector: '.element-video',
        unobserve_entered: true,
        callback_enter: function(el) {
          lazyloader.loadElementVideo(el);
        }
      }));
    }

    if($container.data('social-action-buttons-lazyload')) {
      $container.data('social-action-buttons-lazyload').update();
    } else {
      $container.data('social-action-buttons-lazyload', new LazyLoad({
        container: container,
        elements_selector: '.element-social-action-buttons-group',
        unobserve_entered: true,
        callback_enter: function(el) {
          lazyloader.loadElementSocialActionButtonsGroup(el);
        }
      }));
    }
  },
  loadImg: function(el) {
    var width = el.width;

    if(width > 0) {
      el.setAttribute('data-sizes', width + 'px');
      if(!el.getAttribute('srcset') && el.dataset.srcset) {
        el.setAttribute('srcset', el.dataset.srcset);
        el.removeAttribute('data-srcset');
      }
      if(el.dataset.src && !el.getAttribute('src') && (el.getAttribute('src') != el.dataset.src)) {
        el.setAttribute('src', el.dataset.src);
        el.removeAttribute('data-src');
      }
      picturefill({
        reevaluate: true,
        elements: [el]
      });
    }
  },
  loadBgVideo: function(el) {
    var $el = $(el),
        $video = $el.find('iframe,video');

    if($video.length) $video.attr('src', $video.data('src'));

    var $inner = $el.parent('.bg-video-fallback');
    if ($inner.length) {
      var videoEl = $el.find('video')[0];
      if (videoEl) {
        var showFallback = function() {
          var fallbackUrl = $inner.data('bg-video-fallback');

          if (fallbackUrl) {
            $inner.css('backgroundImage', 'url(' + fallbackUrl + ')');
          }
        };

        if (videoEl.error) {
          showFallback();
        } else {
          $(videoEl).on('error', showFallback);
        }
      }
    }
  },
  loadBgImg: function(el) {
    var $el = $(el),
        windowWidth = $(window).width();

    if($el.hasClass('bg-video-fallback') && (windowWidth > 768 || $el.hasClass('bg-video-force-mobile'))) return;

    if($el.is(':visible') && !($el.data('force-bg-color-on-mobile') && windowWidth < 769)) {
      if($el.data('bg')) {
        $el.css('background-image', 'url(' + $el.data('bg') + ')');
      } else if(windowWidth <= 992 && $el.data('bg-992')) {
        $el.css('background-image', 'url(' + $el.data('bg-992') + ')');
      } else if(windowWidth <= 1199 && $el.data('bg-1199')) {
        $el.css('background-image', 'url(' + $el.data('bg-1199') + ')');
      } else if(windowWidth >= 1200 && $el.data('bg-1200')) {
        $el.css('background-image', 'url(' + $el.data('bg-1200') + ')');
      }
    }
  },
  loadElementAlbum: function(el, $container) {
    new appVisitor.ElementAlbum($(el));
    ImageQueries.refresh($container);
    ElementQueries.refresh();
  },
  loadGoogleMap: function(el) {
    var $el = $(el);
    var $elementMap = $el.parent();

    if(el.tagName == 'iframe') $el.attr('src', $el.data('src'));

    if($elementMap.hasClass('element-map-advanced')) {
      var map = new appVisitor.ElementMapAdvanced($el);
    } else if($elementMap.hasClass('element-map-itinerary')) {
      var map = new appVisitor.ElementMapItinerary($el);
    } else {
      var map = new appVisitor.ElementMapStandard($el);
    }
    map.init();
  },
  loadElementVideo: function(el) {
    var $el = $(el),
        $video = $el.find('iframe,video');

    if(($el.data("view-type") == "modal") && $el.hasClass("element-initialized")) {
      return;
    } else if ($video.length) {
      $video.attr('src', $video.data('src'));
    }

    new appVisitor.ElementVideo($el);
  },
  loadElementSocialActionButtonsGroup: function(el) {
    new appVisitor.ElementSocialActionButtonsGroup($(el)).init();
  },
  skipAll: function($container){
    var lazyloader = this;

    $container.find('img').each(function() { lazyloader.loadImg(this); });
    $container.find('.bg-imaged').each(function() { lazyloader.loadBgImg(this); });
    $container.find('.background-video-background').each(function() { lazyloader.loadBgVideo(this); });
    $container.find('.element-album').each(function() { lazyloader.loadElementAlbum(this, $container); });
    $container.find('.map-container').each(function() { lazyloader.loadGoogleMap(this); });
    $container.find('.element-video').each(function() { lazyloader.loadElementVideo(this); });
    $container.find('.element-social-action-buttons-group').each(function() { lazyloader.loadElementSocialActionButtonsGroup(this); });
  }
}
